import React from 'react';
import { isBasicUser } from 'src/common/session/SessionService';
import { Role } from './Role';

export const BasicUserRole: React.FC = ({ children }) => (
    <Role isRole={isBasicUser}>{children}</Role>
);
